import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
	OnInit,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClientValidatorService, CourseSearchPathService } from '@uc/web/core';
import {
	ClientFeatureOptions,
	ClientFeatures,
	FeaturedClearing,
} from '@uc/web/shared/data-models';
import { Location, NgOptimizedImage } from '@angular/common';
import { CdnPathPipe } from '@uc/utilities';
import { BookmarkComponent } from '@uc/web/shared/features/feature-bookmark';
import {
	SecondaryBlueBtnComponent,
	WriteReviewBtnComponent,
} from '@uc/web/shared/buttons';
import { ClearingVisitWebsiteBtnComponent } from '@uc/web/shared/leads';
import {
	CourseGAService,
	NA,
	UniImpressionDirective,
	UniProfileGAEventDirective,
} from '@uc/web/analytics';
import { ProductEnum } from '@uc/shared/data-models';
import { CtaClearingUniversityBtnsComponent } from '@web/shared/ui';

@Component({
	selector: 'uc-clearing-university-card',
	imports: [
		CdnPathPipe,
		ClearingVisitWebsiteBtnComponent,
		SecondaryBlueBtnComponent,
		CtaClearingUniversityBtnsComponent,
		BookmarkComponent,
		NgOptimizedImage,
		RouterModule,
		WriteReviewBtnComponent,
		UniProfileGAEventDirective,
		UniImpressionDirective,
	],
	templateUrl: './clearing-university-card.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClearingUniversityCardComponent implements OnInit {
	uniName = input.required<string>();
	uniId = input.required<number>();
	uniSlug = input.required<string>();
	uniCover = input.required<string>();
	uniLogo = input.required<string>();
	clientFeatures = input.required<ClientFeatureOptions[]>();
	recommended = input.required<number | undefined>();
	saved = input.required<boolean>();
	displaySeeCoursesBtn = input.required<boolean>();
	cleSearchOrderPosition = input.required<number>();
	privacyPolicyUrl = input.required<string | null>();
	degreeLevel = input.required<string>();
	region = input.required<string>();
	isHECoSSubject = input.required<boolean | null>();

	source = input<string>();
	externalUrl = input<string>('');
	searchTerm = input<string>('');
	displaySearchTerm = input<boolean>();
	phoneNumber = input<string>('');

	isFeatured!: FeaturedClearing;
	internalUniUrl!: string;

	queryParams = computed(() => ({
		...(this.searchTerm() &&
			this.source() !== 'universities' && { search: this.searchTerm() }),
		...(this.uniSlug() && { uni: this.uniSlug() }),
	}));

	searchTermForGA = computed(() =>
		this.source() === 'universities' ? NA : this.searchTerm(),
	);

	readonly clearing = ProductEnum.Clearing;

	constructor(
		public cvSrv: ClientValidatorService,
		private _location: Location,
		private _courseGASrv: CourseGAService,
		private _courseSearchPathSrv: CourseSearchPathService,
	) {}

	ngOnInit(): void {
		this.isFeatured = this.cvSrv.checkFeature(
			this.clientFeatures(),
			ClientFeatures.Clearing,
		);

		this.internalUniUrl = `/universities/${this.uniSlug()}/clearing`;
	}

	/*
	   GA Event when the See all courses button is clicked.
	   Should work when either a search term has been entered or no search term
	   has been entered.
	*/
	onViewMoreCourses() {
		this._courseSearchPathSrv.path.set(this._location.path());
		this._courseGASrv.viewMore(this.uniId(), this.uniName(), this.searchTerm());
	}
}
